import { memo, useCallback, useState } from "react";
import { Box, Button, Chip, Fade, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, MenuItem, Modal, Select, TextField, Typography } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';

import { ReactComponent as CloseIcon } from "../../assets/icons/icon_close.svg"
import { SwitchButton, removeReference } from "../../utils/Reusables";
import { useDispatch, useSelector } from "react-redux";
import ReportFilterFormNew from "./ReportFilterFormNew";
import { reportActions } from "../../redux/reducers/report/reportReducer";
import { ReactComponent as IconFilterDelete } from "../../assets/icons/icon-delete-small.svg"
import { ReactComponent as IconFilterDrag } from "../../assets/icons/icon-report-filter-drag.svg"
import { ReactComponent as IconFilterSetting } from "../../assets/icons/icon-report-filter-setting.svg"

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const ReportViewFilters = ({currentDataset}) => {
    const [filterPopupOpen,setFilterPopupOpen] = useState(false);
    const [currentFilterObj,setCurrentFilterObj] = useState(null);
    const reportDetails = useSelector(state => state.reportDetails)
    const [expanded, setExpanded] = useState(false)
    const dispatch = useDispatch()

    const handleFilterOptions = useCallback((obj,index) => {
        //console.log(obj,index)
        setCurrentFilterObj({filterIndex: index,filterObj: obj})
        setFilterPopupOpen(true)
    })

    const handleChange = (panel) => (event, newExpanded) => {
        if(expanded === panel) {
            setExpanded(false);
        } else {
            setExpanded(panel ?? false);
        }
        
    };

    const handleCloseFilterPopup = useCallback(() => {
        setCurrentFilterObj(null)
        setFilterPopupOpen(false)
    })

    const handleFilterChange = useCallback((event,index,type) => {
        const value = event.target.value
        switch(type){
            case 'title':
                currentFilterObj.filterObj.displayName = value
                break;
            case 'fieldType':
                currentFilterObj.filterObj['fieldType'] = value
                if(value != 'multiselect'){
                    currentFilterObj.filterObj.showSelectAll = false
                }
                break;
            case 'cascaded':
                currentFilterObj.filterObj.cascaded = !currentFilterObj.filterObj.cascaded
                if(!currentFilterObj.filterObj.cascaded){
                    currentFilterObj.filterObj.cascadedWith = ''  
                }
                break;
            case 'cascadedWith':
                currentFilterObj.filterObj.cascadedWith = value
                break;
            case 'showSelectAll':
                currentFilterObj.filterObj.showSelectAll = !currentFilterObj.filterObj.showSelectAll
                break;
            default:
                console.log('Unknown filter',type,currentFilterObj)
                break;
        }
        setCurrentFilterObj({...currentFilterObj})
    })

    const onFilterDrag = useCallback((result) => {
        let details = removeReference(reportDetails)
        let distinationFilter = details.filters.findIndex(obj => obj.onReport && obj.orderPriority === result.destination.index)
        let sourceFilter = details.filters.findIndex(obj => obj.onReport && obj.member === result.draggableId)
        let order = details.filters[sourceFilter].orderPriority
        details.filters[sourceFilter].orderPriority = details.filters[distinationFilter].orderPriority
        details.filters[distinationFilter].orderPriority = order + 1    
        dispatch(reportActions.updateFilterList({ list: [...details.filters] }))    
        //updateReportDetails({...reportDetails,filters:[...reportDetails.filters]})
    })

    const applyReportFilter = useCallback(() => {
        reportDetails.filters.splice(currentFilterObj.filterIndex,1,currentFilterObj.filterObj)
        //updateReportDetails({...reportDetails,filters:[...reportDetails.filters]})
        handleCloseFilterPopup()
    })

    return <>
        <Grid className="report-filters">
            <DragDropContext onDragEnd={onFilterDrag}>
                <Droppable droppableId="filters" direction="vertical">
                    {(provided, snapshot) => (
                        <div
                            className="width-100 field-wells-elements"
                            {...provided?.droppableProps}
                            ref={provided?.innerRef}
                        >
                            {
                                reportDetails.filters && reportDetails.filters.length > 0 && reportDetails.filters.slice().sort((a,b) =>  a.orderPriority - b.orderPriority).map((filterObj, filterIndex) => {
                                    return filterObj.onReport ? 
                                    (
                                        <Draggable key={`report-filter-on-page-${filterIndex}-${filterObj.member}`} draggableId={filterObj.member} index={filterObj.orderPriority}>
                                                {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        <Accordion key={`${filterObj.member}-view-filters-${filterIndex}`} className="re-re-new-filters-listitem-accordion"
                                                            expanded={expanded === `${filterIndex}-view-filters`} 
                                                            // onChange={handleChange(`${filterIndex}-view-filters`)}
                                                        >
                                                            <AccordionSummary aria-controls={`${filterObj?.member}-${filterObj?.operator}-view-filters-content`} 
                                                                id={`${filterObj?.member}-${filterObj?.operator}-view-filters-header`} onClick={handleChange(`${filterIndex}-applied-filters`)}>
                                                                <Box className="re-flex-start">
                                                                    <IconFilterDrag className="re-re-new-filters-listitem-drag" />
                                                                    <Box className="re-flex-between" data-key={`${filterIndex}-applied-filters`} >
                                                                        <Typography component={"h4"} className='re-re-new-filters-listitem-header'>
                                                                            {filterObj.displayName ?? 'New Filter'}
                                                                        </Typography>
                                                                        <Box className="re-flex-align-center">
                                                                            <Typography className='re-re-new-filters-listitem-filter-show' component={'span'} onClick={(e) => {e.stopPropagation();return false}}>
                                                                                {(expanded === `${filterIndex}-applied-filters`) ? `Show on report`: `Hide`}
                                                                            </Typography>
                                                                            <IconFilterDelete className="re-re-new-filters-listitem-delete-filter" onClick={(e) => {e.stopPropagation();return false}} />
                                                                            <IconFilterSetting className="re-re-new-filters-listitem-setting-filter" onClick={(e) => {e.stopPropagation();console.log("112")}}  />
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                            </AccordionSummary>
                                                            <AccordionDetails>
                                                                <Grid className='field-details'>
                                                                    <ReportFilterFormNew currentDataset={currentDataset} filterList={reportDetails.filters} filterObj={filterObj} filterIndex={filterIndex} />
                                                                </Grid>
                                                            </AccordionDetails>
                                                        </Accordion>
                                                        {/*
                                                        <Chip                                                        
                                                            label={filterObj?.displayName || filterObj?.member?.split('.')[1]}
                                                            onDelete={e => handleFilterOptions(filterObj, filterIndex)}
                                                            deleteIcon={<SettingsIcon />}
                                                        />
                                                        */}
                                                    </div>
                                                )}
                                        </Draggable>                                        
                                    ) :
                                    ''                 
                                })
                            }
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </Grid>
        <Modal
            open={filterPopupOpen}
            onClose={handleCloseFilterPopup}
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-root"
        >
            <Fade in={filterPopupOpen}>
                <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                    <CloseIcon onClick={handleCloseFilterPopup} className="enlarge-close" />
                    <Box className="modal-header modal-header2" >
                        <Typography variant="subtitle1" className="modal-header-title" >{`Edit Filter`}</Typography>
                    </Box>
                    <Box className="modal-content modal-content2">
                        {
                            currentFilterObj &&
                            <FormGroup className="width-100" sx={{ mt: 2 }}>
                                <TextField
                                    variant="outlined"
                                    label={'FIlter Title'}
                                    name={'filter-title'}
                                    value={currentFilterObj.filterObj.displayName}
                                    onChange={e => handleFilterChange(e, currentFilterObj.filterIndex, 'title')}
                                />
                                <FormControl sx={{ mt: 2 }}>
                                    <InputLabel id={`${currentFilterObj.filterObj.member}-filter-type`}>Filter Type</InputLabel>
                                    <Select
                                        onChange={e => handleFilterChange(e, currentFilterObj.filterIndex, 'fieldType')}
                                        value={currentFilterObj.filterObj.fieldType ?? ''}
                                        label={'Filter Type'}
                                        labelId={`${currentFilterObj.filterObj.member}-filter-type`}
                                    >
                                        <MenuItem value={'Dropdown'}>Single Select</MenuItem>
                                        <MenuItem value={'multiselect'}>Multiple Select</MenuItem>
                                        <MenuItem value={'input'}>Input Field</MenuItem>
                                    </Select>
                                </FormControl>
                                {
                                    reportDetails && reportDetails.filters && reportDetails.filters.filter(obj => obj.onReport && obj.type != 'time').length > 1 && 
                                    <FormControlLabel
                                        control={<SwitchButton />}
                                        label={'Show Relevant Values'}
                                        checked={currentFilterObj?.filterObj?.cascaded ? true : false}
                                        onChange={e => handleFilterChange(e, currentFilterObj.filterIndex, 'cascaded')}
                                    />                                    
                                }
                                {
                                    currentFilterObj?.filterObj?.cascaded && 
                                    <FormControl sx={{ mt: 2 }}>
                                        <InputLabel id={`${currentFilterObj.filterObj.member}-cascaded-field`}>Select Relevant Filter</InputLabel>
                                        <Select
                                            onChange={e => handleFilterChange(e, currentFilterObj.filterIndex, 'cascadedWith')}
                                            value={currentFilterObj.filterObj.cascadedWith ?? ''}
                                            label={'Select Relevant Filter'}
                                            labelId={`${currentFilterObj.filterObj.member}-cascaded-field`}
                                        >
                                            {
                                                reportDetails.filters.filter(obj => obj.onReport && obj.type != 'time' && obj.member != currentFilterObj.filterObj.member).map((obj,index) => (
                                                    <MenuItem key={`${index}-${obj.member}-cascaded-value`} value={obj.member}>{obj.displayName}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                }
                                {
                                    currentFilterObj?.filterObj?.fieldType === 'multiselect' &&
                                    <FormControlLabel
                                        control={<SwitchButton />}
                                        label={'Show Select All Option'}
                                        checked={currentFilterObj?.filterObj?.showSelectAll ? true : false}
                                        onChange={e => handleFilterChange(e, currentFilterObj.filterIndex, 'showSelectAll')}
                                    />
                                }
                            </FormGroup>
                        }
                        <Grid item xs={12}>
                            <Box sx={{ mt: 2 }} display="flex" justifyContent={'center'}>
                                <Button onClick={applyReportFilter} className="report_form_ui_btn primary text-btn-small mr-2" variant="contained" color="primary" >Update</Button>
                            </Box>
                        </Grid>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    </>
}

export default memo(ReportViewFilters)